import type { AppRedirect } from '#src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/nonprofits',
		buildUrl: ({ queryString }) => `/nonprofit${queryString}`,
		reason: 'canonical-url',
	},
];
